module.exports = __webpack_public_path__ + "static/media/9DESA19.24ed062a.jpg";